module.exports = __webpack_public_path__ + "img/Attack_hellfire.ecf49d89.png";